import './App.css';
import React from 'react';
import MainLayout from './Containers/MainLayout';
import { AuthContextProvider } from './Context/authContext';
import ThemeProvider from './Utils/themeProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from './Utils/i18next/i18n.js';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { AppContextProvider } from './Context/appContext';
import { FormContextProvider } from './Context/formContext';
import { createBrowserHistory } from 'history';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

export const history = createBrowserHistory();

function App() {
  return (
    <HistoryRouter history={history}>
      <AppContextProvider>
        <FormContextProvider>
          <AuthContextProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <ThemeProvider>
                  <I18nextProvider i18n={i18n}>
                    <div className="App">
                      <MainLayout />
                    </div>
                  </I18nextProvider>
                </ThemeProvider>
            </LocalizationProvider>
          </AuthContextProvider>
        </FormContextProvider>
      </AppContextProvider>
    </HistoryRouter>
  );
}

export default App;
